import { useState } from 'react';
import { resolveOrgStatusBucket } from '../../../../domain/superadmin/orgStatus';
import DashboardCard from '../../../dashboard/components/DashboardCard';
import { Button, Textarea } from '../../../../components/ui';
import { OrganizationStatusBadge } from '../OrganizationStatusBadge';

type AccessControlSectionProps = {
  subscriptionStatus: string | null;
  blockedAt: string | null;
  trialEndsAt: string | null;
  onBlock?: (reason: string) => void | Promise<void>;
  onUnblock?: (reason: string) => void | Promise<void>;
  isSaving?: boolean;
};

const MIN_REASON_LENGTH = 20;

export function AccessControlSection({
  subscriptionStatus,
  blockedAt,
  trialEndsAt,
  onBlock,
  onUnblock,
  isSaving = false,
}: AccessControlSectionProps) {
  const [reason, setReason] = useState('');
  const bucket = resolveOrgStatusBucket({ subscriptionStatus, blockedAt, trialEndsAt });
  const isBlocked = bucket === 'blocked';
  const reasonValid = reason.trim().length >= MIN_REASON_LENGTH;
  const canAct = Boolean(isBlocked ? onUnblock : onBlock) && reasonValid && !isSaving;

  const handleSubmit = () => {
    const trimmed = reason.trim();
    if (!reasonValid) return;
    if (isBlocked) {
      void onUnblock?.(trimmed);
      return;
    }
    void onBlock?.(trimmed);
  };

  return (
    <DashboardCard title="Controle de acesso" className="mb-s5">
      <div className="mb-s4 flex flex-wrap items-center gap-s3">
        <span className="text-[12px] text-muted">Status atual:</span>
        <OrganizationStatusBadge
          row={{ subscriptionStatus, blockedAt, trialEndsAt }}
        />
      </div>

      <div className="flex flex-col gap-s4">
        <Textarea
          label="Motivo"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Descreva o motivo operacional (mínimo 20 caracteres)…"
          minRows={3}
          disabled={isSaving || (!onBlock && !onUnblock)}
          helperText={`${reason.trim().length}/${MIN_REASON_LENGTH} caracteres mínimos`}
        />

        <div className="flex flex-wrap justify-end gap-s2">
          <Button
            type="button"
            variant={isBlocked ? 'default' : 'danger'}
            size="sm"
            disabled={!canAct}
            onClick={handleSubmit}
            className="w-full sm:w-auto"
          >
            {isSaving ? 'Processando…' : isBlocked ? 'Desbloquear empresa' : 'Bloquear empresa'}
          </Button>
        </div>
      </div>
    </DashboardCard>
  );
}
